import { renderSlot as _renderSlot, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["TooltipProvider"], { "delay-duration": 0 }, {
        default: _withCtx(() => [
            _createElementVNode("div", _mergeProps({
                "data-slot": "sidebar-wrapper",
                style: {
                    '--sidebar-width': $setup.SIDEBAR_WIDTH,
                    '--sidebar-width-icon': $setup.SIDEBAR_WIDTH_ICON,
                },
                class: $setup.cn('group/sidebar-wrapper has-data-[variant=inset]:bg-sidebar flex min-h-svh w-full', $setup.props.class)
            }, _ctx.$attrs), [
                _renderSlot(_ctx.$slots, "default")
            ], 16 /* FULL_PROPS */)
        ]),
        _: 3 /* FORWARDED */
    }));
}
